<template>
    <v-container grid-list-xl fluid>
        <v-layout>
            <v-flex>
                <h2 class="pr-3">{{ $t('menu.all_contacts') }}</h2>
            </v-flex>
            <v-spacer></v-spacer>
            <v-btn v-if="selectedItems.length > 0" color="primary" @click="showGroupPicker = true; groupSelectedCallback = getGroup">{{$t('action.add_to')}}</v-btn>
            <v-btn color="primary" @click="showNewForm">{{$t('action.add')}}</v-btn>
            <v-menu offset-y>
                <v-btn
                        slot="activator"
                        color="primary"
                        dark
                >
                    {{$t('action.import')}}
                </v-btn>
                <v-list>
                    <v-list-tile
                            @click="uploadDialog.show = true"
                    >
                        <v-list-tile-title>{{$t('contact.import_from_file')}}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile
                            @click="openEventPicker"
                    >
                        <v-list-tile-title>{{$t('contact.import_from_event_guest')}}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-if="getCurrentTeamId"
                            @click="openPersonalContactPicker">
                        <v-list-tile-title>{{$t('contact.import_from_personal_account')}}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-if="(!getCurrentTeamId && (getTeamCount > 0)) || (getCurrentTeamId && (getTeamCount > 1))"
                            @click="openTeamPicker">
                        <v-list-tile-title>{{getCurrentTeamId ? $t('contact.import_from_other_team_contact') : $t('contact.import_from_team_contact')}}</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-layout>

        <v-layout row wrap>
            <v-flex sm6 md3>
                <v-text-field
                  @input="searchContacts"
                  :label="$t('action.search')"
                  v-model="search"
                  clearable
                  clear-icon="close"
                  append-icon="search"
                  :loading="searching"
                ></v-text-field>
            </v-flex>
        </v-layout>

        <v-layout row wrap v-scroll="onScroll">
            <template v-for="(item, i) in items">
                <v-flex :key="i" xs12 sm6 md4>
                    <v-card
                        style="cursor: pointer;"
                        @click="item.selected = !item.selected"
                        @contextmenu.prevent="item.showMenu = true"
                        :dark="item.selected"
                        :color="item.selected ? 'primary' : ''"
                        :class="[{'elevation-10': item.selected}, 'pa-2']"
                    >
                        <v-card-title primary-title style="padding: 0;">

                            <v-flex xs3 sm2 class="pa-2">
                                <v-icon x-large>person</v-icon>
                            </v-flex>
                            <v-flex xs6 sm8 class="pa-2">
                                <div>
                                    <div class="font-weight-bold">{{item.name}}</div>
                                    <div>{{item.areaCode}} {{item.phone}}</div>
                                </div>
                            </v-flex>
                            <v-flex xs3 sm2 class="text-xs-right pa-2">
                                <v-menu
                                    v-model="item.showMenu"
                                    bottom
                                    left
                                >
                                    <v-btn
                                        slot="activator"
                                        icon
                                        @click.capture.stop="item.showMenu = true"
                                    >
                                        <v-icon>more_vert</v-icon>
                                    </v-btn>

                                    <v-list>
                                        <v-list-tile
                                            :key="1"
                                            @click="editItem(item)"
                                        >
                                            <v-list-tile-title>{{$t('action.edit')}}</v-list-tile-title>
                                        </v-list-tile>
                                        <v-list-tile
                                            :key="2"
                                            @click="deleteItem(item)"
                                        >
                                            <v-list-tile-title>{{$t('action.delete')}}</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12 class="py-0" v-if="item.contact_groups.length">
                                <template v-for="contact_group in item.contact_groups">
                                    <v-chip
                                            @click=""
                                            small
                                            label
                                            outline
                                            disabled
                                            :dark="item.selected"
                                            :color="item.selected ? 'white' : ''"
                                    ><v-icon left>group</v-icon>{{contact_group.name}}</v-chip>
                                </template>
                            </v-flex>
                        </v-card-title>
                    </v-card>
                </v-flex>
            </template>
        </v-layout>
        <div class="text-xs-center">
            <v-progress-circular v-show="loading" color="grey" :indeterminate="true"></v-progress-circular>
        </div>

        <contact-edit-dialog
            v-model="form.show"
            :item="form.item"
            @success="editSuccess"
        ></contact-edit-dialog>

        <upload-dialog
          ref="uploadDialog"
          v-model="uploadDialog.show"
          :title="$t('action.import')"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          :maxSizeInMB="5"
          type="event"
          bypassUpload
          @success="uploadSuccess"
        >
            <v-flex xs12 class="text-xs-right">
                <v-icon>fa-download fa-lg</v-icon> <span class="grey--text" v-html="$t('upload.use_this_template')"></span>
            </v-flex>
        </upload-dialog>

        <group-picker
          v-model="showGroupPicker"
          :title="$t('contact.add_contact_to')"
          @success="groupSelectedCallback"
        >
        </group-picker>

        <event-picker
            v-model="eventPicker.show"
            @success="eventSelectedCallback"
        >
        </event-picker>

        <event-guest-picker
                v-model="eventGuestPicker.show"
                :title="getEventGuestTitle"
                :event_id="eventGuestPicker.event_id"
                @success="guestSelectedCallback"
        >
        </event-guest-picker>

        <team-picker
            v-model="teamPicker.show"
            :title="$t('contact.import_from_team_contact')"
            @success="teamSelectedCallback"
        />

        <contact-picker
                v-model="teamContactPicker.show"
                :title="getTeamContactTitle"
                :team-id="teamContactPicker.team_id"
                :exclude="items"
                :show_add_to_group_checkbox="true"
                :show-group-filter="true"
                @success="teamContactSelectedCallback"
        >
        </contact-picker>

        <contact-picker
                v-model="personalContactPicker.show"
                :title="$t('contact.personal_contact')"
                :exclude="items"
                :show_add_to_group_checkbox="true"
                :personal-contact="true"
                :show-group-filter="true"
                @success="personalContactSelectedCallback"
        >
        </contact-picker>


    </v-container>
</template>

<script>
    import i18n from '~/i18n'
    import RequestHandler from '~/utils/request-handler'
    import {UrlServices} from '~/utils/url-manager'
    import formatter from '~/utils/formatter'
    import UploadDialog from '~/components/common/UploadDialog.vue'
    import GroupPicker from '~/components/contact/GroupPicker'
    import EventPicker from '~/components/event/EventPicker'
    import ContactEditDialog from '~/components/contact/ContactEditDialog'
    import ExcelReader from '~/utils/excel-reader'
    import importMixin from './import-mixin'
    import { CancelToken } from 'axios'
    import EventGuestPicker from "~/components/event/EventGuestPicker";
    import TeamPicker from "~/components/team/TeamPicker";
    import ContactPicker from "~/components/contact/ContactPicker";

    const ImportFromType = {
        FILE: 0,
        EVENT: 1,
        TEAM: 2,
        PERSONAL_CONTACT: 3
    };

    export default {
        components: {
            ContactPicker,
            TeamPicker,
            EventGuestPicker,
            UploadDialog,
            GroupPicker,
            ContactEditDialog,
            EventPicker,
        },
        mixins: [importMixin],
        data () {
            return {
                loading: false,
                page: 1,
                bottomReached: true,
                items: [],
                areaCodes: ['+852'],
                form: {
                    show: false,
                    item: {
                        id: 0,
                        name: '',
                        areaCode: '+852',
                        phone: ''
                    },
                    // rules: {
                    //     required: value => !!value || this.$t('form.field_required')
                    // },
                    // phoneMask: '#'.repeat(50),
                    // errors: {
                    //     name: '',
                    //     phone: ''
                    // }
                },
                uploadDialog: {
                    show: false
                },
                search: '',
                searching: false,
                cancel: () => {},
                showGroupPicker: false,
                eventPicker: {
                    show: false
                },
                teamPicker: {
                    show: false
                },
                eventGuestPicker: {
                    show: false,
                    event_name: '',
                    event_id: 0
                },
                teamContactPicker: {
                    show: false,
                    team_name: '',
                    team_id: 0
                },
                personalContactPicker: {
                    show: false
                },
                toContactGuests: []
            }
        },
        computed: {
            selectedItems() {
                return _.filter(this.items, x => {return x.selected});
            },
            getEventGuestTitle() {
                return i18n.t('event.event_guest_title', {
                    'event': this.eventGuestPicker.event_name
                })
            },
            getTeamContactTitle() {
                return i18n.t('team.team_contact_title', {
                    'team': this.teamContactPicker.team_name
                })
            },
            getCurrentTeamId() {
                return this.$store.state.user_info.current_team_id;
            },
            getTeamCount() {
                return this.$store.state.teams_data.length;
            }
        },
        methods: {
            getContacts: _.debounce(function(search) {
                let me = this;
                me.loading = true;
                let config = {
                    cancelToken: new CancelToken(function executor(c) {
                        me.cancel = c;
                    })
                };
                let params = {
                    page: me.page,
                    search: search,
                    record_per_page: 0
                };
                RequestHandler.Get(UrlServices.createUrl({'name': 'api_contact_list'}), params, {
                    'success': function(data){
                        _.each(data.data, x => {
                            x.showMenu = false;
                            x.selected = false;
                            formatter.parsePhone(x);
                            me.items.push(x);
                        });

                        me.loading = false;
                        me.searching = false;
                        if (me.page < data.total_page) {
                            me.bottomReached = false;
                        }
                        me.page++;
                    }
                }, config);
            }, 0),
            searchContacts: _.debounce(function(search) {
                this.cancel();
                this.page = 1;
                this.searching = true;
                this.items = [];
                this.$nextTick(function() {
                    this.getContacts(search);
                });
            }, 500),
            showNewForm() {
                this.form.item = {
                    showMenu: true,
                    areaCode: '+852'
                };
                this.form.show = true;
            },
            editItem(item) {
                //console.log('editItem', item);
                item.showMenu = false;
                this.form.item = _.extend({}, item);    // Create a object to temporarily store the changes
                this.form.show = true;
            },
            editSuccess(data) {
                //console.log('editSuccess', data);

                let item = _.find(this.items, x => {
                    return x.id == data.id;
                });

                if (item) {
                    item.phone = data.phone;
                    item.name = data.name;
                    item.contact_groups = data.contact_groups;
                    formatter.parsePhone(item);
                } else {
                    let newItem = {
                        id: data.id,
                        name: data.name,
                        phone: data.phone,
                        contact_groups: data.contact_groups,
                        showMenu: false,
                        selected: false
                    };
                    this.items.push(formatter.parsePhone(newItem));
                }

                this.form.show = false;
                getApp.snackbar = {
                    show: true,
                    color: 'green',
                    text: this.$t('app.msg_edit_success'),
                    timeout: 3000
                };
            },
            deleteItem(item) {
                //console.log('deleteItem', item);
                item.showMenu = false;
                let me = this;
                RequestHandler.Post(UrlServices.createUrl({'name': 'api_contact_delete'}), {id: item.id}, {
                  'success': function(){
                    me.items = _.filter(me.items, x => {
                      return x.id !== item.id;
                    });

                    me.form.show = false;
                    getApp.snackbar = {
                      show: true,
                      color: 'green',
                      text: me.$t('app.msg_delete_success'),
                      timeout: 3000
                    };
                  }
                });
            },
            onScroll() {
                let offset = window.innerHeight * 3;
                if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - offset) {
                    // you're at the bottom of the page
                    if (!this.bottomReached) {
                        this.bottomReached = true;
                        this.getContacts();
                    }
                }
            },
            uploadSuccess(item) {
                ExcelReader(item.file, this.importData);
            },
            importData (contacts, groups, import_from_type = ImportFromType.FILE) {
                let me = this;
                if (me.parseImportData(contacts)) {
                    RequestHandler.Post(UrlServices.createUrl({'name': 'api_contact_import'}), {contacts: contacts, groups: groups}, {
                        'success': function (res) {
                            //console.log('success', res);
                            _.each(res, n => {
                                let item = _.find(me.items, x => {
                                    return x.id == n.id;
                                });
                                if (item) {
                                    item = _.extend(item, n);
                                }
                            });

                            switch(import_from_type) {
                                case ImportFromType.FILE:
                                    me.uploadDialog.show = false;
                                    break;
                                case ImportFromType.EVENT:
                                    me.showGroupPicker = false;
                                    me.eventGuestPicker.show = false;
                                    break;
                                case ImportFromType.TEAM:
                                    me.showGroupPicker = false;
                                    me.teamContactPicker.show = false;
                                    break;
                                case ImportFromType.PERSONAL_CONTACT:
                                    me.showGroupPicker = false;
                                    me.personalContactPicker.show = false;
                                    break;
                            }

                            me.searchContacts(me.search);

                            getApp.snackbar = {
                                show: true,
                                color: 'green',
                                text: me.$t('contact.import_success'),
                                timeout: 3000
                            };
                        }
                    });
                }
            },
            groupSelectedCallback() { },
            getGroup(group) {
                //console.log('getGroup', group);
                this.addContacts(group, () => {
                    _.each(this.selectedItems, x => {
                        x.selected = false;
                    });
                    this.showGroupPicker = false;
                });
            },
            getGroupToSaveEventGuests(group) {
                _.each(this.toContactGuests, function(item){
                    item.groupId = group.id;
                });
                this.importData(this.toContactGuests, [], ImportFromType.EVENT);
            },
            getGroupToSaveTeamContacts(group) {
                _.each(this.toContactGuests, function(item){
                    item.groupId = group.id;
                });
                this.importData(this.toContactGuests, [], ImportFromType.TEAM);
            },
            getGroupToSavePersonalContacts(group) {
                _.each(this.toContactGuests, function(item){
                    item.groupId = group.id;
                });
                this.importData(this.toContactGuests, [], ImportFromType.PERSONAL_CONTACT);
            },
            addContacts(group, callback) {
                let data = {
                    id: group.id,
                    contacts: _.map(this.selectedItems, 'id')
                };
                let me = this;
                RequestHandler.Post(UrlServices.createUrl({'name': 'api_contact_group_save'}), data, {
                    'success': function(data){
                        //console.log('success', data);
                        if (callback) callback();
                        getApp.snackbar = {
                            show: true,
                            color: 'green',
                            text: me.$t('app.msg_edit_success'),
                            timeout: 3000
                        };
                    },
                    'error': function(error) {
                        console.log('error', error);
                        getApp.snackbar = {
                            show: true,
                            color: 'red',
                            text: error.msg,
                            timeout: 3000
                        };
                    }
                });
            },
            openEventPicker: function() {
                this.eventPicker.show = true;
                this.toContactGuests = [];
            },
            openTeamPicker: function() {
                this.teamPicker.show = true;
                this.toContactGuests = [];
            },
            openPersonalContactPicker: function() {
                this.personalContactPicker.show = true;
                this.toContactGuests = [];
            },
            teamSelectedCallback: function(team) {
                this.teamPicker.show = false;
                this.teamContactPicker.team_id = team.id;
                this.teamContactPicker.team_name = team.name;
                this.teamContactPicker.show = true;
            },
            eventSelectedCallback: function(event) {
                // this.groupPickerCallback = this.getGroupToSaveGuest;
                this.eventPicker.show = false;
                // this.showGroupPicker = true;
                this.eventGuestPicker.event_id = event.id;
                this.eventGuestPicker.event_name = event.title;
                this.eventGuestPicker.show = true;
            },
            teamContactSelectedCallback: function(contacts, add_to_group) {
                this.guestSelectedCallback(contacts, add_to_group, ImportFromType.TEAM);
            },
            personalContactSelectedCallback: function(contacts, add_to_group) {
                this.guestSelectedCallback(contacts, add_to_group, ImportFromType.PERSONAL_CONTACT);
            },
            guestSelectedCallback: function(guests, add_to_group, import_from_type = ImportFromType.EVENT) {
                let toContactGuests = [];
                _.each(guests, function(guest) {
                    toContactGuests.push({
                        areaCode: guest.areaCode,
                        phone: guest.phone,
                        name: guest.name
                    });
                });
                this.toContactGuests = toContactGuests;
                if(add_to_group) {
                    switch(import_from_type) {
                        case ImportFromType.EVENT:
                        default:
                            this.groupSelectedCallback = this.getGroupToSaveEventGuests;
                            break;
                        case ImportFromType.TEAM:
                            this.groupSelectedCallback = this.getGroupToSaveTeamContacts;
                            break;
                        case ImportFromType.PERSONAL_CONTACT:
                            this.groupSelectedCallback = this.getGroupToSavePersonalContacts;
                            break;

                    }
                    this.showGroupPicker = true;
                } else {
                    this.importData(this.toContactGuests, [], import_from_type);
                }
            }
        },
        mounted() {
            this.getContacts();
        }
    }
</script>

<style scoped>
    #editForm {
        width: 100%;
    }
</style>